import { render } from "./TravelPage.vue?vue&type=template&id=4012d818&scoped=true"
import script from "./TravelPage.vue?vue&type=script&lang=js"
export * from "./TravelPage.vue?vue&type=script&lang=js"

import "./TravelPage.vue?vue&type=style&index=0&id=4012d818&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4012d818"]])

export default __exports__